import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';

const ChannelSwitchTabs = ({ activeKey, tabs, onSelect }) => {
  const [selectedKey, setSelectedKey] = useState(activeKey);

  useEffect(() => {
    setSelectedKey(activeKey);
  }, [activeKey]);

  const selectTab = (eventKey) => {
    if (onSelect) onSelect(eventKey);

    setSelectedKey(eventKey);
  };

  return (
    <Tab.Container activeKey={selectedKey} onSelect={selectTab}>
      <Nav className="nav nav-tabs nav-tabs-light">
        {tabs.map(({ eventKey, title }) => {
          return (
            <Nav.Item key={eventKey}>
              <Nav.Link eventKey={eventKey}>{title}</Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
    </Tab.Container>
  );
};

ChannelSwitchTabs.propTypes = {
  activeKey: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      eventKey: PropTypes.string.isRequired,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    }),
  ).isRequired,
  onSelect: PropTypes.func,
};

export default ChannelSwitchTabs;
